export const FilterSearchBar = (props) => {
    return <div className={`col-sm-${props.filter.gridWidth != 0 ? props.filter.gridWidth : 12}`}>
        <input type={"search"} className={"searchBar"}
            placeholder={props.filter.placeHolder}
            onChange={(evt) => props.setSearchTermHandler(evt.target.value)} />
    </div>;
}